import React from 'react';

const ReportCard = ({ title, value, subtitle, badge, children }) => {
  return (
    <div className="flex h-full flex-col justify-between rounded-3xl border border-gray-200 bg-white p-5 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-sm font-semibold uppercase tracking-wide text-gray-500">{title}</div>
          <div className="mt-3 text-3xl font-bold text-slate-900">{value}</div>
          {subtitle && <div className="mt-2 text-sm text-gray-500">{subtitle}</div>}
        </div>
        {badge && (
          <div className="rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-700">{badge}</div>
        )}
      </div>
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
};

export default ReportCard;
